<template>
  <div class="nav-container m-header">
    <div class="navbar header-div">
      <div class="header-logo" @click="toHome()">
        <div class="logo-img" style="width: 40px;">
          <!--          <img class="title-img" src="../../../assets/img/logo.png">-->
        </div>
        <div class="logo-title">公卫辅助及慢病健康管理系统</div>
        <div style="position: absolute; left: 65px; top: 38px; font-weight: bolder; height: 20px; line-height: 20px;">（{{orgName}}）</div>

      </div>
      <div class="header-menu" id="headerMenu">
        <el-menu
          class="el-menu-demo"
          mode="horizontal"
          background-color="#1890FF"
          text-color="#fff"
          @select="handleSelect"
          :default-active="onRoutes">
          <template v-for="(item, index) in menuList">
            <el-menu-item  :key="index + 'el-submenu'" :index="item.name" :class="{ 'is-active': selectedPath == item.name }">
              {{ item.meta != null ? item.meta.title : ''}}
            </el-menu-item>
          </template>
          <el-submenu v-if="moreArr.length > 0" class="menuItem" index="99999">
            <template slot="title">更多</template>
            <template v-for="(item, index) in moreArr">
              <template v-if="item.children && item.children.length > 0">
                <el-submenu :key="index + 'el-submenu'" :index="item.name">
                  <template slot="title">
                    <i :class="item.meta.icon"></i>
                    <span>{{ item.meta != null ? item.meta.title : ''}}</span>
                  </template>
                  <template v-for="(subItem, subIndex) in item.children">
                    <template v-if="subItem.children && subItem.children.length > 0 && !subItem.leaf">
                      <el-submenu :key="subIndex + 'el-submenu2'" :index="subItem.name">
                        <template slot="title">
                          <i :class="subItem.meta.icon"></i>
                          <span>{{ subItem.meta != null ? subItem.meta.title : '' }}</span>
                        </template>
                        <el-menu-item
                          v-for="(threeItem, threeIndex) in subItem.children"
                          :key="threeIndex"
                          :index="threeItem.name"
                        >{{ threeItem.meta != null ? threeItem.meta.title : '' }}</el-menu-item>
                      </el-submenu>
                    </template>
                    <el-menu-item
                      v-else
                      :key="subIndex"
                      :index="subItem.name"
                    ><i :class="subItem.meta.icon"></i>{{ subItem.meta != null ? subItem.meta.title : '' }}</el-menu-item>
                  </template>
                </el-submenu>
              </template>
              <el-menu-item
                v-else
                :key="index"
                :index="item.name"
              ><i :class="item.meta.icon"></i>{{ item.meta != null ? item.meta.title : '' }}</el-menu-item>
            </template>
          </el-submenu>
        </el-menu>
      </div>
      <ul class="header-right">
        <li class="header-single" style="width: 60px; cursor: pointer; text-align: right; margin-right: 20px;" @click="handleOpenPhSearch">
          <img style="height: 30px; margin-top: 13px;" src="../../../assets/img/ph-search.png"/>
        </li>

        <li class="header-single"
            style="width: 40px; cursor: pointer; text-align: right; margin: 0px 10px;"
            @click="setPhPassword">
          <img class="flash-icon"
               style="height: 30px; margin-top: 13px;"
               src="../../../assets/img/reminder-icon.png"
               :class="{ 'flash-animation': userInfo.phCheckStatus !== '1' }" />
        </li>
<!--        <li class="header-single"
            style="width: 40px; cursor: pointer; text-align: right; margin: 0px 10px;"
            @click="toExaminePage">
          <img class="flash-icon"
               style="height: 30px; margin-top: 13px;"
               src="../../../assets/home/use/examine-icon.png"
               alt="体检检查"/>
        </li> -->
        <li class="header-single"
            v-if="userInfo.nowUserLevel === '9'"
            style="width: 40px; cursor: pointer; text-align: right; margin: 0px 10px;"
            @click="toQuestionPage">
          <img class="flash-icon"
               style="height: 30px; margin-top: 13px;"
               src="../../../assets/home/use/question-list.png"
               alt="问题列表"/>
        </li>
        <li class="header-single">
          <el-dropdown class="header-photo" trigger="click" @command="moreMenuClick" id="righted">
            <div class="user-container">
              <img class="head-user-photo" :src="userInfo.headImg" v-if="!!userInfo.headImg">
              <img class="head-user-photo" src="../../../assets/img/default.png" v-if="!userInfo.headImg">
              <div class="head-user-name" style="position: relative;">
                <div style="text-align: left;">{{userInfo.realname}}</div>
                <div style="position: absolute; top:18px; left: -20px;" v-if="!!userInfo.teamName">（{{userInfo.teamName}}）</div>
              </div>
            </div>
            <el-dropdown-menu slot="dropdown" class="el-dropdown-unarrow">
              <el-dropdown-item
                v-for="(item, index) in moreMenu"
                :key="index"
                :command="item.command"
                :divided="item.divided"
                :icon="item.icon"
              >{{ item.label }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </ul>
    </div>
    <!--修改密码-->
    <CheckPassWord ref="checkPassWord" v-if="checkPassWordShow"></CheckPassWord>
    <!--基本信息-->
    <header-page-base-info ref="baseInfo" v-if="baseInfoShow" @getUserInfo = getUserInfo></header-page-base-info>
    <!--资源中心-->
    <down-list ref="downList" v-if="isDownloadShow"></down-list>

    <!-- 偏好设置 -->
    <person-setting ref="personSetting" v-if="isPersonSettingShow"></person-setting>
    <!--字符内容-->
    <word-info ref="wordInfo" v-if="isWordInfoShow"></word-info>
    <!-- 页面布局 -->
    <page-layout-set ref="pageLayoutSet" v-if="isPageLayoutSetShow"></page-layout-set>
    <!--标准文件-->
    <std-file-view-list-dialog ref="stdFileViewList" v-if="isStdFileShow"></std-file-view-list-dialog>
    <el-drawer :with-header="false" :visible.sync="drawer" :direction="direction" :before-close="handleCloseTodoDrawer">
      <todo></todo>
    </el-drawer>

    <!-- 切换主题 -->
    <switch-theme v-if="isSwitchThemeShow" ref="switchTheme"></switch-theme>
    <!-- 公司信息 -->
    <company-info v-if="isCompanyInfoShow" ref="companyInfo"></company-info>

    <!-- 公卫查询 -->
    <ph-search  v-if="isPhSearchShow" ref="phSearch"></ph-search>

    <!-- 设置公卫账户和密码 -->
    <user-edit-ph-password ref="userEditPhPassword"  v-if="isUserEditPhPasswordShow" @refreshUserInfo="getUserInfo"></user-edit-ph-password>

    <!-- 体检检查 -->
    <examine-check ref="examineCheck" v-if="isExamineCheckShow"></examine-check>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CheckPassWord from '../../checkPassword'
import HeaderPageBaseInfo from '../../HeaderPageBaseInfo'
import WordInfo from "../../WordInfo";
import DownList from "../../../views/common/Down-list";
import store from '../../../store'
import SwitchTheme from "../../header/SwitchTheme.vue";
import CompanyInfo from "../../header/CompanyInfo.vue"
import PhSearch from "../../header/PhSearch";
import UserEditPhPassword from '../../../views/common/user-edit-ph-password'
import PersonSetting from "../../../views/common/person-setting"
import ExamineCheck from "../../../views/examine/examine-check-index"

export default {
  name: "headerPage",
  data() {
    return {
      drawer: false,
      direction: 'ltr',
      unreadNums: {
        announceCount : 1,
        allCount: 1,
      },
      selectedPath: '',           //选择的地址
      menuOptions: [],            //可选列表
      userInfo: {
        realname: '张三',
        userId:'',
        headImg:'',
        phCheckStatus: '',         //公卫认证状态
        phUserName: '',            //公卫用户名
        teamName: '',              //团队名称
        nowUserLevel: '',          //当前用户等级
      },
      orgName: '',
      menuList: [],            //常规菜单列表
      moreArr: [],             //更多的列表
      checkPassWordShow: false,
      isSwitchThemeShow: false,                   //是否显示【切换标题】
      isCompanyInfoShow: false,                   //是否显示【公司信息】
      isPhSearchShow: false,                      //是否显示【公卫查询】
      isUserEditPhPasswordShow: false,            //是否显示 [公卫账户密码设置]
      baseInfoShow: false,
      isDownloadShow: false,        //资源中心
      isProductManualShow: false,   //产品手册
      isWordInfoShow: false,        //字符内容
      isStdFileShow: false,        //标准文件
      isPersonSettingShow: false,        //偏好设置
      isStdFileButtonShow: false,        //标准文件按钮
      isPageLayoutSetShow: false,                   //是否显示【页面设置】
      isMessageButtonShow: false,                   //通知按钮
      isMessageDialogShow: false,                   //显示通知弹窗
      isExamineCheckShow: false,                    //是否显示体检检查
      messageNum: 0 , //右上角消息按钮的数字显示

    };
  },
  computed: {
    ...mapGetters([
      'routesLists'
    ]),
    moreMenu() {
      return [{
        command: 'baseInfo',
        divided: false,
        label: '基本信息',
        icon: 'wk wk-user'
      },{
        command: 'checkPass',
        divided: false,
        label: '修改密码',
        icon: 'wk wk-user'
      },
        {
          command: 'download',
          divided: false,
          label: '资源中心',
          icon: 'wk wk-user'
        },
        {
          command: 'setting',
          divided: false,
          label: '偏好设置',
          icon: 'wk wk-user'
        },
        // {
        //   command: 'switchTheme',
        //   divided: false,
        //   label: '切换主题',
        //   icon: 'wk wk-user'
        // },
        // {
        //   command: 'codeGenerate',
        //   divided: false,
        //   label: '代码生成',
        //   icon: 'wk wk-user'
        // },
        // {
        //   command: 'bi',
        //   divided: false,
        //   label: '智能分析',
        //   icon: 'wk wk-user'
        // },
        // {
        //   command: 'companyInfo',
        //   divided: false,
        //   label: '充值信息',
        //   icon: 'wk wk-user'
        // },
        {
          command: 'logOut',
          divided: false,
          label: '退出登录',
          icon: 'wk wk-logout'
        }]
    },
    onRoutes() {
      let route = this.$route;
      if(route.meta && !!route.meta.topName){
        this.selectedPath = route.meta.topName;
      }
      let path = route.path.replace("/", "");
      return path;
    },
  },
  components: {
    CheckPassWord,
    HeaderPageBaseInfo,
    WordInfo,
    SwitchTheme,
    CompanyInfo,
    PhSearch,
    DownList,
    UserEditPhPassword,
    PersonSetting,
    ExamineCheck
  },
  created () {
    this.$nextTick(()=>{
      this.menuOptions = this.routesLists;
      this.orgName = localStorage.getItem('orgName');
      this.initMenu();       //初始化菜单列表
      this.getUserInfo();    //获取用户信息
    })
  },
  methods: {
    //设置公卫账户密码
    setPhPassword() {
      this.isUserEditPhPasswordShow = true
      this.$nextTick(() => {
        this.$refs.userEditPhPassword.init(this.userInfo.userId);
      });
    },
    //体检检查
    toExaminePage(){
      this.isExamineCheckShow = true
      this.$nextTick(()=>{
        this.$refs.examineCheck.resetForm()
        this.$refs.examineCheck.init()
      })
    },
    //去首页
    toHome(){
      window.location.href = "/";
    },
    //获取登录信息
    getUserInfo() {
      this.userInfo.userId = this.$store.state.user.userId
      this.userInfo.realname = this.$store.state.user.name
      this.request({
        method:'post',
        url:'/web/service?method=tCoreUser_getUserInfo',
      }).then((response) =>{
        if (response && response.code === 0) {

          this.userInfo.userId = response.data.user.id
          this.userInfo.realname = response.data.user.userName
          this.userInfo.phCheckStatus =  response.data.phCheckStatus || ''
          this.userInfo.teamName =  response.data.user.teamName || ''
          this.userInfo.nowUserLevel =  response.data.nowUserLevel || ''
          if(!!response.data.user.photo){
            this.userInfo.headImg = process.env.FILE_URL + '/web/getResource/' + response.data.user.photo;
          }
          // 更新右上角图标权限
          let serviceCodes = ',' + localStorage.getItem('serviceCodes') + ','
          if (serviceCodes.concat(',METAL_STDLIST,')){  //金属方法查看列表
            this.isStdFileButtonShow = true;
          }
          if (serviceCodes.concat(',METAL_MESSAGE,')){  //金属方法查看列表
            this.isMessageButtonShow = true;
          }
        }
      })
    },

    handleSelect(path) {
      this.selectedPath = path;
      this.$router.push(path)
    },

    //关闭待办页面
    handleCloseTodoDrawer(done){
      done();
    },
    //打开待办的页面
    handleOpenTodoDrawer() {
      this.drawer = true;
      // this.$router.push('/report-manage');
    },
    moreMenuClick(command) {
      if (command == 'baseInfo') {  //如果是 【个人信息】
        this.baseInfoShow = true;
        this.$nextTick(()=>{
          this.$refs.baseInfo.init(this.userInfo.userId) ;//初始化页面
        })

      } else if (command == 'logOut') {
        this.$store.dispatch('user/logout')
          .then(() => {
            location.reload()
          })
          .catch(() => {
            location.reload()
          })
      }else if (command == 'checkPass'){
        this.checkPassWordShow = true;
        this.$nextTick(()=>{
          this.$refs.checkPassWord.init(this.userInfo.userId) ;//初始化页面
        })
      }else if (command == 'switchTheme'){     //切换主题
        this.isSwitchThemeShow = true;
        this.$nextTick(()=>{
          this.$refs.switchTheme.init() ;//初始化页面
        })
      }else if (command == 'companyInfo'){     //公司信息
        this.isCompanyInfoShow = true;
        this.$nextTick(()=>{
          this.$refs.companyInfo.init() ;//初始化页面
        })
      }else if (command === 'codeGenerate'){
        // this.$router.push('generate')
        window.open(this.$router.resolve('generate').href, '_blank')
      }else if (command === 'bi'){
        this.$router.push('bi')
        window.open(this.$router.resolve('bi').href, '_blank')
      }else if (command === 'download'){
        this.isDownloadShow = true;
        this.$nextTick(()=>{
          this.$refs.downList.init() ;//初始化页面
        })
      }if (command === 'setting'){    //偏好设置
        this.isPersonSettingShow = true;
        this.$nextTick(()=>{
          this.$refs.personSetting.resetTemp()
          this.$refs.personSetting.init() ;
        })
      }
      else if (command === 'productManual'){
        this.$router.push('common-productManual')
        // this.isProductManualShow = true;
        // this.$nextTick(()=>{
        //   this.$refs.productManual.init() ;//初始化页面
        // })
      }else if (command === 'layoutSet'){        //页面布局
        this.isPageLayoutSetShow = true;
        this.$nextTick(()=>{
          this.$refs.pageLayoutSet.init() ;//初始化页面
        })
      }else if (command === 'wordInfo'){
        this.isWordInfoShow = true;
        this.$nextTick(()=>{
          this.$refs.wordInfo.init() ;//初始化页面
        })
      }
    },
    //打开公卫查询
    handleOpenPhSearch() {
      this.isPhSearchShow = true;
      this.$nextTick(()=>{
        this.$refs.phSearch.init() ;//初始化页面
      })
    },
    //去问题列表页面
    toQuestionPage() {
      window.open("https://docs.qq.com/sheet/DRU1YVG1kSndmY09C?no_promotion=1&tab=0xenv2", "_blank");
    },
    initWordInfo() {
      this.isWordInfoShow = true;
      this.$nextTick(()=>{
        this.$refs.wordInfo.init() ;//初始化页面
      })
    },
    // 打开文档
    initDocument() {
      this.$router.push('document-info')
    },
    // 初始化标准文件
    initStdFile() {
      this.isStdFileShow = true;
      this.$nextTick(()=>{
        this.$refs.stdFileViewList.init() ;//初始化页面
      })
    },
    //初始化菜单列表
    initMenu(){
      //判断能显示的数量  headerMenu
      let allMenuWidth = document.getElementById("headerMenu").offsetWidth;
      if(!allMenuWidth){
        allMenuWidth = 1000;
      }
      let menuNum = parseInt(allMenuWidth/100) - 2
      for (let i = 0; i < this.routesLists.length; i++) {
        let temp = this.routesLists[i];
        if(this.menuList.length < menuNum){
          this.menuList.push(temp);
        }else{
          this.moreArr.push(temp);
        }
      }
      // console.log('+++++++++++++++++++');
      // console.log(this.menuList);


      // let newArr = JSON.parse(JSON.stringify(this.data));
      // let menuitem = document.getElementsByClassName("menuItem");
      // let widthArr = [];
      // for (let i = 0; i < menuitem.length; i++) {
      //   widthArr.push(menuitem[i].clientWidth);
      // }
      // this.isBeyond(widthArr);
      // //更多的数组
      // let arr = [];
      // if (this.existing != 0) {
      //   arr = newArr.splice(this.existing, newArr.length - 1);
      // }
      // this.moreArr = arr;
    },
    isBeyond(widthArr) {
      let menu = document.getElementsByClassName("menuList");
      if (this.sum(widthArr) > menu[0].clientWidth) {
        this.isb = true;
        let newArr = this.data.slice(0, this.data.length - 1);
        let newWidthArr = widthArr.slice(0, this.data.length - 1);
        this.data = newArr;
        this.isBeyond(newWidthArr);
      } else {
        if (this.isb) {
          let newArr = this.data.slice(0, this.data.length - 1);
          let newWidthArr = widthArr.slice(0, this.data.length - 1);
          this.data = newArr;
          this.existing = newWidthArr.length;
        }
      }
    },
    sum(arr) {
      return arr.reduce(function (prev, curr, idx, arr) {
        return prev + curr;
      });
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.menuId,
        label: node.menuName,
        children: node.children
      };
    },
    // 设置右上角 消息栏的数字增长
    addMessage(){
      if (this.isMessageButtonShow){
        this.messageNum ++;
      }
    },
    //初始化消息弹窗
    initMessageDialog(){
      this.isMessageDialogShow = true;
      this.$nextTick(()=>{
        this.$refs.messageListDialog.init();
      })
    },
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>

.nav-container {padding: 0;box-shadow: 0px 1px 2px #dbdbdb;z-index: 100;min-width: 1200px;font-size: 15px;}

.header-div{height: 58px;min-height: 58px;display: flex;align-items: center;position: relative;padding: 0 5px;background: #1890FF;}
.header-div .header-logo{height: 58px;line-height: 58px;margin-right: 20px;}
.header-div .header-logo .logo-img{float: left;height: 58px;}
.header-div .header-logo .logo-img img{margin-top: 10px;}
.header-div .header-logo .logo-title {display: inline-block;color: #FFF;white-space: nowrap;font-size: 19px;text-align: center;cursor: pointer;font-weight: 500;}
.header-div .header-menu{flex: 1;display: flex;min-width: 500px;height: 100%;overflow-x: auto;line-height: 58px;font-size: 15px;}
.header-div .header-right{float: right;position: relative;height: 58px;line-height: 58px;right: 10px;}
.header-div .header-right .header-single{float: left;text-align: center;position: relative;}
.header-photo{height: 58px;line-height: 58px;margin-left: 30px;}
// 图标字体
.iconWord{ font-size: 17px;line-height: 58px;vertical-align:bottom;}
.omega-button {font-size: 20px;line-height: 58px;background: transparent;color: white;width: 40px;padding-left: 10px;padding-right: 10px;}


.header-div .header-menu .el-menu--horizontal>.el-menu-item{height: 58px;line-height: 58px;}
.m-header {height: 58px !important;}


.header-div .el-menu{background: #1890FF;}
.header-div .el-menu--horizontal .el-menu-item{color: #FFF;margin: 0;padding: 0 16px;font-size: 16px;}
//.header-div .el-menu--horizontal .el-menu-item:hover{background: #3d4251;opacity:0.8;}
.header-div .el-menu--horizontal>.el-submenu .el-submenu__title{color: #fff;margin: 0;padding: 0 16px;height: 58px;line-height: 58px;}
.main-table .header-div.sortableColumn + .caret-wrapper{display: block;}

// 菜单
.el-menu {overflow: hidden;}
.el-menu-item{ margin: 0 !important;}

//li的高度
.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{height: 30px !important;line-height: 30px !important;font-size: 12px;padding: 0 10px !important;}
.el-menu.el-menu--horizontal {border-bottom: none;}
.el-menu-item {padding: 0;margin: 0 20px;font-size: 16px;color: #2a304d;}


// 系统消息
.wk-announcement,
.wk-bell {
  color: #9DA9C2;
  cursor: pointer;
  font-size: 20px;
}

.el-badge {
  margin-right: 20px;
}

.user-container {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
  .user-img {
    margin-right: 8px;
  }
  .mark {
    font-size: 15px;
    color: #aaaaaa;
  }
}

.user-container:hover {
  .mark {
    color: #2486e4;
  }
}

.el-menu-item {
  padding: 0;
  margin: 0 20px;
  font-size: 16px;
  font-weight: 500;
  color: #2a304d;
  i {
    color: #5c6075;
  }
}


.el-dropdown-unarrow{
  width: 100px;
}

.head-user-photo{
  height: 30px;
  width: 30px;
  border-radius: 30px;
  margin-right: 8px;
}

.head-user-name{color: #FFF; font-size: 12px; min-width: 80px;}

.header-select-main {line-height: 29px;float: left;width: 150px;height: 29px;line-height: 29px;}
.header-select-main .vue-treeselect__control {height: 29px !important;}
.header-select-main .vue-treeselect__placeholder {line-height: 29px;}
.header-select-main .vue-treeselect__single-value {line-height: 29px;}

.flex-container {
  float: right; /* 向右浮动 */
  display: flex;
  align-items: center; /* 垂直居中 */
  margin-right: 20px;
}


//#righted{
//  float: right; /* 向右浮动 */
//  display: flex;
//}
.stdFile{ /* 右上角金属标准文件图标  */
  display: inline-block;
  width: 18px;
  height: 18px;
  background-image: url('../../../assets/img/检验标准文件.png');
  background-size: 18px;
}

//定义闪烁动画
@keyframes flashAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}
.flash-animation {
  animation: flashAnimation 0.6s ease-in-out infinite;
}
</style>




// WEBPACK FOOTER //
// src/components/theme/theme3/HeaderPage.vue